import { cx } from '../../utils';
import styles from './CdDivider.module.scss';

export interface CdDividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export const CdDivider = ({ orientation = 'horizontal', className }: CdDividerProps) => {
  return orientation === 'horizontal' ? (
    <hr className={cx(styles.divider, styles.horizontal, className)} />
  ) : (
    <span
      role="separator"
      aria-orientation="vertical"
      className={cx(styles.divider, styles.vertical, className)}
    />
  );
};
